const DEFAULT_LABEL = 'PROMOCJA'
const DEFAULT_BACKGROUND_COLOR = '#ea580c'
const DEFAULT_TEXT_COLOR = '#ffffff'

export class PriceBadge {
  readonly isHidden: boolean
  readonly currentPrice: number
  readonly originalPrice: number | null
  private readonly customLabel: string | null
  private readonly customBackgroundColor: string | null
  private readonly customTextColor: string | null

  constructor(data: {
    isHidden: boolean
    currentPrice: number
    maxHistoricalPrice: number | null
    label?: string | null
    backgroundColor?: string | null
    textColor?: string | null
  }) {
    this.isHidden = data.isHidden
    this.currentPrice = data.currentPrice

    const max = data.maxHistoricalPrice
    this.originalPrice = (max !== null && max > data.currentPrice) ? max : null

    this.customLabel = data.label ?? null
    this.customBackgroundColor = data.backgroundColor ?? null
    this.customTextColor = data.textColor ?? null
  }

  get isVisible(): boolean {
    return !this.isHidden && this.originalPrice != null
  }

  get label(): string {
    return this.customLabel ?? DEFAULT_LABEL
  }

  get backgroundColor(): string {
    return this.customBackgroundColor ?? DEFAULT_BACKGROUND_COLOR
  }

  get textColor(): string {
    return this.customTextColor ?? DEFAULT_TEXT_COLOR
  }
}
